import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
/**
 * Hook to call onSuccess callback when an order is executed.
 * Handles fallback to relayTxs when executeTx is null.
 */
export function useOnOrderSuccess(t0) {
  const $ = _c(10);
  const {
    orderData,
    orderId,
    onSuccess
  } = t0;
  const onSuccessCalled = useRef(false);
  const prevOrderId = useRef(orderId);
  let t1;
  if ($[0] !== onSuccess || $[1] !== orderData?.data?.executeTx?.txHash || $[2] !== orderData?.data?.order.status || $[3] !== orderData?.data?.relayTxs || $[4] !== orderId) {
    t1 = () => {
      if (prevOrderId.current !== orderId) {
        onSuccessCalled.current = false;
        prevOrderId.current = orderId;
      }
      if (orderData?.data?.order.status === "executed" && !onSuccessCalled.current) {
        const relayTxs = orderData?.data?.relayTxs;
        const lastSuccessfulRelayTx = relayTxs?.filter(_temp).pop();
        const txHash = orderData?.data?.executeTx?.txHash || lastSuccessfulRelayTx?.txHash;
        onSuccess?.(txHash);
        onSuccessCalled.current = true;
      }
    };
    $[0] = onSuccess;
    $[1] = orderData?.data?.executeTx?.txHash;
    $[2] = orderData?.data?.order.status;
    $[3] = orderData?.data?.relayTxs;
    $[4] = orderId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== onSuccess || $[7] !== orderData || $[8] !== orderId) {
    t2 = [orderData, orderId, onSuccess];
    $[6] = onSuccess;
    $[7] = orderData;
    $[8] = orderId;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  useEffect(t1, t2);
}
function _temp(tx) {
  return tx.status === "success";
}